import React, { useState } from "react";
import { MdCurrencyRupee } from "react-icons/md";
import { TbAlertTriangle, TbCircleCheck, TbPencil } from "react-icons/tb";
import {
  Box,
  Button,
  Checkbox,
  Col,
  Dialog,
  Divider,
  FabButton,
  Flex,
  Gap,
  InputField,
  Row,
  SelectField,
  Switchbox,
  Typography,
} from "../../../ppui";
import { Snackbar } from "../../../ppui/snackbar";
import { theme } from "../../../theme";
import { AllowanceBox } from "../../style";

const PayAndBenefits = () => {
  const [salaryBreakdown, setSalaryBreakdown] = React.useState(false);


  // Initial state values
  const grossSalary = 20000;
  const basicSalaryPercent = 50;

  // Allowances
 
  const allowances = [
    { name: 'House Rent Allowance', amount: 3800 },
    { name: 'Traveling Allowance', amount: 2200 },
    { name: 'Fooding Allowance', amount: 1350 }
  ];
  // Calculate Basic Salary
  const basicSalary = (grossSalary * basicSalaryPercent)/100;

  // Calculate Total Allowances
  const totalAllowances = allowances.reduce((sum, allowance) => sum + allowance.amount, 0);

  // Calculate Total Salary Components
  const [totalSalaryComponents, setTotalSalaryComponents] = useState(basicSalary + totalAllowances);
  // Shortfall calculation
  const shortfall = grossSalary - totalSalaryComponents;

  // State for final adjustments
  const [specialAllowance, setSpecialAllowance] = useState(0);
  const [adjustedBasicSalary, setAdjustedBasicSalary] = useState(basicSalary);
  const [adjustedBasicSalaryPercent, setAdjustedBasicSalaryPercent] = useState(basicSalaryPercent);

  // Adjust Basic Salary function
  const adjustBasicSalary = () => {
    setAdjustedBasicSalary(basicSalary + shortfall);
    setSpecialAllowance(0); // Reset special allowance
    setTotalSalaryComponents(basicSalary+ shortfall + totalAllowances)
    setAdjustedBasicSalaryPercent(((basicSalary+ shortfall)/grossSalary)*100)
  };

  // Adjust Allowances function
  const adjustAllowances = () => {
    setSpecialAllowance(shortfall); // Allocate shortfall to allowances
    setTotalSalaryComponents(basicSalary+ shortfall + totalAllowances)
  };

  // Adjust manually function (this can be expanded further)
  const adjustManually = () => {
    // alert('manually increases one or more allowances or basic salary to reach.');
    snackbarOpen()
    SalaryBreakdownClose();
  };

  const SalaryBreakdownOpen = () => {setSalaryBreakdown(true)};
  const SalaryBreakdownClose = () => {
    setSalaryBreakdown(false)
    
    setSpecialAllowance(0);
    setAdjustedBasicSalaryPercent(basicSalaryPercent)
    setAdjustedBasicSalary(basicSalary); 
    setTotalSalaryComponents(basicSalary + totalAllowances);
  };
  const [snackbarVisible, setSnackbarVisible] = useState(false);


  const snackbarOpen = () => {
    setSnackbarVisible(true);
  };
  return (
    <>
      <Typography variant="h5">Salary Structure</Typography>
      <Row rowGap>
        <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
          <SelectField


          
            fullWidth
            label="Salary Type"
            options={[
              { id: "salary", name: "Salary" },
              { id: "wages", name: "Wages" },
            ]}
            defaultValue="salary"
            placeholder="Select Here..."
          />
        </Col>

        <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
          <SelectField
            fullWidth
            label="Salary known"
            options={[
              { id: "Basic", name: "Basic" },
              { id: "Gross", name: "Gross" },
            ]}
            placeholder="Select Here..."
          />
        </Col>

        <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
          <InputField
            fullWidth
            label="Basic Percentage"
            placeholder="Type Here..."
            type="number"
            prefix={"%"}
            value={"50"}
            valueSinc
          />
        </Col>

        <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
          <InputField
            fullWidth
            label="Basic Salary"
            placeholder="Type Here..."
            type="number"
            suffix={<MdCurrencyRupee />}
          />
        </Col>
        <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
          <InputField
            fullWidth
            label="Grose Salary"
            placeholder="Type Here..."
            type="number"
            suffix={<MdCurrencyRupee />}
          />
        </Col>

        <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
          <SelectField
            fullWidth
            label="Payment Mode"
            options={[
              { id: "Account Transfer", name: "Account Transfer" },
              { id: "Cheque", name: "Cheque" },
              { id: "Cash", name: "Cash" },
            ]}
            placeholder="Select Here..."
          />
        </Col>

        <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
          <InputField
            fullWidth
            label="OT Rate"
            placeholder="Type Here..."
            type="number"
            prefix={"%"}
          />
        </Col>

        <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
          <SelectField
            fullWidth
            label="Labour Welfare Fund"
            options={[
              { id: "Yes", name: "Yes" },
              { id: "No", name: "No" },
            ]}
            placeholder="Select Here..."
          />
        </Col>
      </Row>

      <Divider gap={20} />


      <Row rowGap>
        <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
          <SelectField
            fullWidth
            label="Salary Type"
            options={[
              { id: "salary", name: "Salary" },
              { id: "wages", name: "Wages" },
            ]}
            defaultValue="wages"
            placeholder="Select Here..."
          />
        </Col>

        <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
          <SelectField
            fullWidth
            label="Wage Type"
            options={[
              { id: "Days", name: "Days" },
              { id: "Hours", name: "Hours" },
              { id: "per", name: "Per/Piecs" },
            ]}
            placeholder="Select Here..."
          />
        </Col>

        <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
          <InputField
            fullWidth
            label="Wage Rate"
            placeholder="Type Here..."
            type="number"
          />
        </Col>
        <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
          <SelectField
            fullWidth
            label="Wage Payment Mode"
            options={[
              { id: "Weekly", name: "Weekly" },
              { id: "Fortnight pay", name: "Fortnight pay" },
              { id: "Monthly", name: "Monthly" },
            ]}
            placeholder="Select Here..."
          />
        </Col>

        <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
          <InputField
            fullWidth
            label="Wage Days"
            placeholder="Type Here..."
            type="number"
            suffix={<MdCurrencyRupee />}
          />
        </Col>

        <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
          <InputField
            fullWidth
            label="Grose Salary"
            placeholder="Type Here..."
            type="number"
            suffix={<MdCurrencyRupee />}
          />
        </Col>
        <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
          <SelectField
            fullWidth
            label="Payment Mode"
            options={[
              { id: "Account Transfer", name: "Account Transfer" },
              { id: "Cheque", name: "Cheque" },
              { id: "Cash", name: "Cash" },
            ]}
            placeholder="Select Here..."
          />
        </Col>

        <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
          <InputField
            fullWidth
            label="OT Rate"
            placeholder="Type Here..."
            type="number"
            prefix={"%"}
          />
        </Col>

        <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
          <SelectField
            fullWidth
            label="Labour Welfare Fund"
            options={[
              { id: "Yes", name: "Yes" },
              { id: "No", name: "No" },
            ]}
            placeholder="Select Here..."
          />
        </Col>
      </Row>

      <Divider gap={20} />
      <Flex justifyContent="space-between" mb={18} gap={"10"}>
        <Typography variant="h5" mb={"0"}>
          Employee Allowance data
        </Typography>
        <Button onClick={() => {}} variant="outlined" size="sm">
          Update
        </Button>
      </Flex>
      <Flex gap={20} direction={"column"}>
        <AllowanceBox>
          <Row alignItems="center">
            <Col xs={1}>
              <Checkbox color="primary" />
            </Col>
            <Col xs={10}>
              <Flex alignItems="center" gap={{ md: 20, lg: 40, xxl: 60 }}>
                <Box>
                  <Box className="label">Allowance Name</Box>
                  <Box className="value">Travaling</Box>
                </Box>

                <Box>
                  <Box className="label"> Type</Box>
                  <Box className="value">Fixed</Box>
                </Box>
                <Box>
                  <Box className="label"> Ammount</Box>
                  <Box className="value">200</Box>
                </Box>
                <Box>
                  <Box className="label"> No Work No Pay</Box>
                  <Box className="value">Yes</Box>
                </Box>
                <Box>
                  <Box className="label"> ESI Wages</Box>
                  <Box className="value">Yes</Box>
                </Box>
                <Box>
                  <Box className="label"> EPF Wages</Box>
                  <Box className="value">No</Box>
                </Box>
              </Flex>
            </Col>

            <Col xs={1}>
              <Box>
                <FabButton
                  size="sm"
                  icon={<TbPencil />}
                  onClick={() => {}}
                  variant="filled"
                  shape="box"
                />
              </Box>
            </Col>
          </Row>
        </AllowanceBox>


        <AllowanceBox>
          <Row alignItems="center">
            <Col xs={1}>
              <Checkbox color="primary" />
            </Col>
            <Col xs={10}>
              <Flex alignItems="center" gap={{ md: 20, lg: 40, xxl: 60 }}>
                <Box>
                  <Box className="label">Allowance Name</Box>
                  <Box className="value">Travaling</Box>
                </Box>

                <Box>
                  <Box className="label"> Type</Box>
                  <Box className="value">Fixed</Box>
                </Box>
                <Box>
                  <Box className="label"> Ammount</Box>
                  <Box className="value">200</Box>
                </Box>
                <Box>
                  <Box className="label"> No Work No Pay</Box>
                  <Box className="value">Yes</Box>
                </Box>
                <Box>
                  <Box className="label"> ESI Wages</Box>
                  <Box className="value">Yes</Box>
                </Box>
                <Box>
                  <Box className="label"> EPF Wages</Box>
                  <Box className="value">No</Box>
                </Box>
              </Flex>
            </Col>

            <Col xs={1}>
              <Box>
                <FabButton
                  size="sm"
                  icon={<TbPencil />}
                  onClick={() => {}}
                  variant="filled"
                  shape="box"
                />
              </Box>
            </Col>
          </Row>
        </AllowanceBox>


        <AllowanceBox>
          <Row alignItems="center">
            <Col xs={1}>
              <Checkbox color="primary" />
            </Col>
            <Col xs={10}>
              <Flex alignItems="center" gap={{ md: 20, lg: 40, xxl: 60 }}>
                <Box>
                  <Box className="label">Allowance Name</Box>
                  <Box className="value">Travaling</Box>
                </Box>

                <Box>
                  <Box className="label"> Type</Box>
                  <Box className="value">Fixed</Box>
                </Box>
                <Box>
                  <Box className="label"> Ammount</Box>
                  <Box className="value">200</Box>
                </Box>
                <Box>
                  <Box className="label"> No Work No Pay</Box>
                  <Box className="value">Yes</Box>
                </Box>
                <Box>
                  <Box className="label"> ESI Wages</Box>
                  <Box className="value">Yes</Box>
                </Box>
                <Box>
                  <Box className="label"> EPF Wages</Box>
                  <Box className="value">No</Box>
                </Box>
              </Flex>
            </Col>

            <Col xs={1}>
              <Box>
                <FabButton
                  size="sm"
                  icon={<TbPencil />}
                  onClick={() => {}}
                  variant="filled"
                  shape="box"
                />
              </Box>
            </Col>
          </Row>
        </AllowanceBox>
      </Flex>

        <Gap height={20}/>
        <Button onClick={SalaryBreakdownOpen}  color="primary"  variant="outlined">
          View Salary Breakdown
        </Button>
      <Divider gap={20} />
      <Flex justifyContent="space-between" mb={18} gap={"10"}>
        <Typography variant="h5" mb={"0"}>
          Weekly Holiday
        </Typography>
        <Switchbox label="Payable Days" color="Primary" size="lg" lableFirst />
      </Flex>

      <Row rowGap mb={20}>
        <Col xs={"auto"}>
          <Checkbox color="primary" label={"Sunday"} />
        </Col>

        <Col xs={"auto"}>
          <Checkbox color="primary" label={"Monday"} />
        </Col>

        <Col xs={"auto"}>
          <Checkbox color="primary" label={"Tuesday"} />
        </Col>

        <Col xs={"auto"}>
          <Checkbox color="primary" label={"Wednesday"} />
        </Col>

        <Col xs={"auto"}>
          <Checkbox color="primary" label={"Thursday"} />
        </Col>

        <Col xs={"auto"}>
          <Checkbox color="primary" label={"Friday"} />
        </Col>

        <Col xs={"auto"}>
          <Checkbox color="primary" label={"Saturday"} />
        </Col>
      </Row>
      <Gap height={100} />
      <Flex justifyContent="flex-end" gap={"10"}>
        <Button onClick={() => {}} variant="outlined">
          Cancel
        </Button>
        <Button color="primary" onClick={SalaryBreakdownOpen}  variant="outlined">
          Save & Exit
        </Button>
        <Button color="primary" onClick={SalaryBreakdownOpen}  variant="contained">
          Next
        </Button>
      </Flex>
      <Dialog
        title="Salary Breakdown Calculation"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        open={salaryBreakdown}
        onClose={SalaryBreakdownClose}
        onSubmit={() => alert("Submitted")}
        separator
        bodyScroll={true}
        buttonName={"Procced"}
        action={!shortfall && true }
      >
        
          <Box px={10} py={15} style={{borderRadius:theme.radius.list}} bgColor={theme.colors.background.main} mb={15}>
            <Typography variant="body2" color='primary' colorVariant='light' fontWeight={500}>Gross Salary = ₹ {grossSalary}.00</Typography>
            <Typography variant="body2" color='primary' colorVariant='light' fontWeight={500}>Basic Salary = {adjustedBasicSalaryPercent.toFixed(2)}% of Gross Salary </Typography>
          </Box>
          <Typography variant="body2" color='default' colorVariant='light'>The breakup of salary will be:</Typography>
          <Divider gap={15} />
          <Box>
            <Typography variant="body1" color='primary' fontWeight={500}>Salary Breakdown </Typography>
            <Flex justifyContent="space-between" gap={"10"}>
              <Typography variant="body2">Basic Salary ({adjustedBasicSalaryPercent.toFixed(2)}% of Gross Salary)</Typography>
              <Typography variant="body2">₹ {adjustedBasicSalary}.00</Typography>
            </Flex>
            {allowances.map((allowance, index) => (
              <Flex justifyContent="space-between" gap={10} key={index}>
                <Typography variant="body2">{allowance.name}</Typography>
                <Typography variant="body2">₹ {allowance.amount}.00</Typography>
              </Flex>
            ))}
            {specialAllowance > 0 && (
              <Flex justifyContent="space-between" gap={10}>
                <Typography variant="body2">Special Allowance</Typography>
                <Typography variant="body2">₹ {specialAllowance}.00</Typography>
              </Flex>
            )}
            <Divider gap={15} />
            <Flex justifyContent="space-between" gap={"10"}>
              <Typography variant="body2" color='primary' fontWeight={500} mb='0'>Total </Typography>
              <Typography variant="body2" color='primary' fontWeight={500} mb='0'>₹ {totalSalaryComponents}.00</Typography>
            </Flex>
            <Divider gap={15} />
            <Gap height={10} />
            {shortfall > 0 ? (
              <>
                <AllowanceBox>
                  <Typography variant="h3" color={"danger"} mb={"0"}>
                  <TbAlertTriangle />
                  </Typography>
                  <Typography variant="body1" display="flex" gap={10} alignItem="center" mb={"0"} p={15}>
                    Total salary components are below the designated Gross Salary. Choose an adjustment method
                  </Typography>
                </AllowanceBox>
              </>
            ):(
              <>
                <AllowanceBox>
                  <Typography variant="h3" color={"success"} mb={"0"}>
                  <TbCircleCheck />
                  </Typography>
                  <Typography variant="body1" display="flex" gap={10} alignItem="center" mb={"0"} p={15}>
                  The salary allocation is successfully balanced. The total of all components matches the Gross Salary, No adjustments are needed.
                  </Typography>
                </AllowanceBox>
              </>
            )
            }    
            {shortfall > 0 && (    
              <>
                <Gap height={10} />
                <Divider gap={15} />
                <Gap height={10} />
                <Flex justifyContent="flex-end" gap={"10"}>
                  <Button color="primary" variant="contained" onClick={adjustBasicSalary}>
                  Adjust in Basic Salary
                  </Button>
                  <Button color="primary" variant="contained" onClick={adjustAllowances}>
                  Adjust in Allowances
                  </Button>
                  <Button color="primary" variant="contained" onClick={adjustManually} >
                  Adjust in Manually
                  </Button>
                </Flex>
              </>
            )}
          </Box>

        
      </Dialog>
      <Snackbar
          message={
            <>
              Please review the adjustments 
            </>
          }
          color="warning"
          variant="contained"
          size="medium"
          position="top-right"
          onOpen={snackbarVisible}
          loading={false}
          duration={3000}
        />
    </>
  );
};

export default PayAndBenefits;
